import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  text-align: center;
`;

export const Text = styled.div`
  font-size: 3rem;
  color: #e4e8f7 !important;
  font-weight: bold;
`;
